import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';

if (typeof window.requestIdleCallback !== 'function') {
  window.requestIdleCallback = (callback, options) =>
    window.setTimeout(
      () => callback({ didTimeout: false, timeRemaining: () => 0 }),
      options?.timeout ?? 1,
    );
}

if (typeof window.cancelIdleCallback !== 'function') {
  window.cancelIdleCallback = handle => window.clearTimeout(handle);
}

bootstrapApplication(AppComponent, appConfig).catch((err: unknown) => console.error(err));
